import {FormTextField} from "./FormTextField";
import {Grid, MenuItem} from "@mui/material";
import * as React from "react";

function FermentationTimingSettingsControl(props) {
  const {pctName, pctLabel, pctValue, pctValueArr, tempName, tempLabel, tempValue, tempValueArr, change, stateLabel} = props

  return (
          <Grid item container direction={'row'} marginTop={2}>
            <FormTextField select size={'small'} sx={{width: '47%'}}
                           id={`${pctName}`}
                           label={`${pctLabel}`}
                           name={`${pctName}`}
                           value={pctValue}
                           onChange={change}>
              {
                pctValueArr.map((v) => {
                  return <MenuItem key={v} value={v}>{`${v}% ${stateLabel}`}</MenuItem>
                })
              }
            </FormTextField>
            <FormTextField select size={'small'} sx={{width: '47%', marginLeft: 1}}
                           id={`${tempName}`}
                           label={`${tempLabel}`}
                           name={`${tempName}`}
                           value={tempValue}
                           onChange={change}>
              {
                tempValueArr.map((v) => {
                  return <MenuItem key={v.key} value={v.key}>{v.label}</MenuItem>
                })
              }
            </FormTextField>
          </Grid>
  )
}

export {FermentationTimingSettingsControl}